var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoAssignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F2EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 21.4931V17.8264C25.6667 15.6649 25.6667 14.5851 24.9957 13.9132C24.3237 13.2422 23.2439 13.2422 21.0833 13.2422H18.3333C16.1727 13.2422 15.092 13.2422 14.421 13.9132C13.75 14.5851 13.75 15.6649 13.75 17.8264V25.1598C13.75 27.3213 13.75 28.402 14.421 29.0739C14.9893 29.6423 15.8519 29.7284 17.4167 29.7422M17.4167 16.9089H22M17.4167 20.5755H22",
    stroke: "#7A5AF8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4629 13.7328L27.01 13.1319L26.2736 12.9769L26.8745 12.524L27.0295 11.7876L27.4824 12.3886L28.2188 12.5435L27.6178 12.9965L27.4629 13.7328ZM29.3136 13.4481L29.6235 11.9753L30.5294 13.1773L32.0022 13.4872L30.8003 14.393L30.4903 15.8658L29.5845 14.6639L28.1117 14.354L29.3136 13.4481ZM27.7879 15.1918L28.2408 15.7927L28.9772 15.9477L28.3763 16.4006L28.2213 17.137L27.7684 16.536L27.032 16.3811L27.633 15.9282L27.7879 15.1918Z",
    fill: "#7A5AF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1739 24.7305C27.2828 24.5986 27.4389 24.5145 27.6089 24.496C27.7789 24.4775 27.9495 24.5261 28.0842 24.6315C28.1503 24.6827 28.2056 24.7467 28.2466 24.8196C28.2876 24.8926 28.3135 24.973 28.3229 25.0561C28.3323 25.1393 28.325 25.2235 28.3013 25.3037C28.2776 25.384 28.2381 25.4587 28.185 25.5234L24.7383 29.7584C24.6807 29.8284 24.6091 29.8856 24.5281 29.9265C24.4472 29.9674 24.3587 29.991 24.2681 29.996C24.1775 30.0009 24.087 29.9869 24.0021 29.955C23.9172 29.9231 23.8398 29.874 23.7749 29.8106L21.1899 27.2715L21.145 27.2238C20.9378 26.9745 20.9525 26.6069 21.1899 26.3741C21.4273 26.1412 21.8023 26.1266 22.0562 26.3301L22.1048 26.3741L24.1856 28.4091L27.1831 24.7332L27.1739 24.7305Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoAssignIcon);
export default __webpack_public_path__ + "static/media/Auto-Assign-icon.864ee18a35107cc927679604e167e725.svg";
export { ForwardRef as ReactComponent };